import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import { Delete, Check, Cancel} from "@mui/icons-material"


export const DisplaySingleContact = ({ count, prompt, onDelete }) => {

  const [confirmDelete, setConfirmDelete] = React.useState(false);

  let {
    promptAreaRef,
    isLoading,
} = React.useContext(StatusContext);

const formatDisplay = (contact) => {
 
  let s = `Name: ${contact.name}\nCompany name: ${contact.companyname}\nEmail: ${contact.email}\n\nSubject: ${contact.subject}\nText: ${contact.text}`
  return s;
}

  
 
  return (
    <div className='promptContainer'>
      <div className='promptWhoContainer'>
      
      <div className="promptWho" >{count}. Date: {prompt.date}</div>
    

        <div className='btn-group' role='group' style={{ fontSize: '14px' }}>
          {
             confirmDelete ?
             <>
              <Check  className="promptIcon" onClick={() => { !isLoading && onDelete(prompt.id) }} />
              <Cancel  className="promptIcon" onClick={() => { !isLoading && setConfirmDelete(false) }}/>
             </>
           :
            <Delete className="promptIcon" onClick={() => {  !isLoading && setConfirmDelete(true) }} />
          }
        </div>
     </div>

      <textarea className="promptTemplate" disabled = {isLoading} ref = {promptAreaRef}
                rows="8" value={formatDisplay(prompt)} readOnly id={prompt.id}>
      </textarea>

     
    </div>
  )
}

